export default "__VITE_ASSET__DaFL3lej__"